import { Box, Heading, Anchor } from 'grommet';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import StyledParagraph from './components/StyledParagraph';

export interface AppProps {}

const App: React.FC<AppProps> = (): JSX.Element => {
  const navigate = useNavigate();

  const onAbout = (): void => {
    navigate('/about');
  };

  return (
    <Box align="center" justify="center">
      <Heading>Hello, Grommet!</Heading>
      <StyledParagraph>This paragraph is rendered with styled-components.</StyledParagraph>
      <Anchor label="Go to About" onClick={onAbout} />
    </Box>
  );
};

App.displayName = 'App';

export default App;
